import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const LoadingScreen = () => {
  const { themeColor, isLoading } = useTheme();

  if (!isLoading) return null;

  return (
    <motion.div
      className="fixed inset-0 z-[9999] bg-[#050505] flex items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-center">
        {/* Animated Logo */}
        <motion.div
          className="relative w-24 h-24 mx-auto mb-8"
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
          <div
            className="absolute inset-0 rounded-full border-4 border-transparent"
            style={{ borderTopColor: themeColor.primary, borderRightColor: themeColor.primary }}
          />
          <div
            className="absolute inset-2 rounded-full border-4 border-transparent"
            style={{ borderBottomColor: themeColor.primary, borderLeftColor: themeColor.primary }}
          />
          <motion.div
            className="absolute inset-0 flex items-center justify-center text-3xl"
            style={{ color: themeColor.primary }}
            animate={{ scale: [1, 1.2, 1], rotate: [0, 180, 360] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            ✶
          </motion.div>
        </motion.div>

        {/* Loading Text */}
        <motion.div
          className="flex items-center gap-1 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <span className="text-zinc-400 text-lg">Yükleniyor</span>
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="text-zinc-400 text-lg"
              animate={{ opacity: [0, 1, 0] }}
              transition={{ duration: 1, repeat: Infinity, delay: i * 0.2 }}
            >
              .
            </motion.span>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
